import Currency, {formatCurrency} from "../../currency/Currency";
import {StoreItem} from "../../../../app/store/store";
import {MAX_MONTHS, totalForMonths} from "./monthPricing";
import "./MonthSelector.css";
import {useTranslation} from "react-i18next";

export default function MonthSelector(props: {
    item: StoreItem
    currency: Currency
    currencyName: string
    months: number
    setMonths: (months: number) => void
}) {
    const {item, currency, currencyName, months, setMonths} = props;
    const {t} = useTranslation();

    return <div className={"month-selector"}>
        {Array.from({length: MAX_MONTHS}, (_, i) => i + 1).map(option => {
            return <button
                key={option}
                type={"button"}
                className={`month-option${option === months ? " selected" : ""}`}
                onClick={() => setMonths(option)}>
                <span className={"count"}>{t("common.months", {count: option})}</span>
                <span className={"total"}>{formatCurrency(currency, totalForMonths(item, option, currencyName))}</span>
            </button>;
        })}
    </div>;
}
